import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].GET_EQUIPMENT_FACTPLACES]: {
		url: '/company/:companyId/equipment/:equipmentId/factplaces/',
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].GET_EQUIPMENT_FACTPLACE]: {
		url: '/company/:companyId/equipment/:equipmentId/factplaces/:factplaceId/',
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].CREATE_EQUIPMENT_FACTPLACE]: {
		url: '/company/:companyId/equipment/:equipmentId/factplaces/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].PATCH_EQUIPMENT_FACTPLACE]: {
		url: '/company/:companyId/equipment/:equipmentId/factplaces/:factplaceId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].PUT_EQUIPMENT_FACTPLACE]: {
		url: '/company/:companyId/equipment/:equipmentId/factplaces/:factplaceId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].DELETE_EQUIPMENT_FACTPLACE]: {
		url: '/company/:companyId/equipment/:equipmentId/factplaces/:factplaceId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
